import {
  getContactsCrud,
  getHpUsersCrud,
} from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/cruds'
import { useMemo } from 'react'

interface IProps {
  partnerId?: string
  groupId: number | null
}
export const useUsers = ({ partnerId, groupId }: IProps) => {
  const usersCrud = useMemo(() => {
    return getHpUsersCrud()
  }, [])

  const contactsCrud = useMemo(() => {
    return getContactsCrud({ partnerId, groupId })
  }, [])
  return { usersCrud, contactsCrud }
}
